define('datakit/model.registry',[
  'backbone.radio',
  './ajax'
], function(
  Radio,
  // include to make sure its radio
  // events are registered
  ajax
) {

  var ModelRegistry = {

    channelName: 'models',

    channel: function() {
      return Radio.channel(ModelRegistry.channelName);
    },

    get: function(name) {
      return ModelRegistry.channel().request(name);
    },

    getAsync: function(name, fn, context) {
      if (ModelRegistry.has(name)) {
        fn.call(context || this, ModelRegistry.get(name));
      } else {
        ModelRegistry.channel().once('register:' + name, function() {
          fn.call(context || this, ModelRegistry.get(name));
        }, this);
      }
      return this;
    },

    has: function(name) {
      var requests = ModelRegistry.channel()._requests;
      return !!(requests && requests[name]);
    },

    register: function(name, Model) {
      var channel = ModelRegistry.channel();
      channel.reply(name, function() {
        return Model;
      });
      channel.trigger('register:' + name);
      return ModelRegistry;
    }

  };

  return ModelRegistry;
})
;
